import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import matter from 'front-matter';
import { articles } from '../data/articles';
import type { Article } from '../types/article';

export interface ArticleMetadata extends Article {
  title: string;
  description: string;
  date: string;
  readTime: string;
  category: string;
  imageUrl: string;
  imageUrl2x?: string;
}

export async function fetchArticleMetadata(
  articleSlug: string,
  language: string
): Promise<ArticleMetadata | undefined> {
  try {
    const article = articles.find((a) => a.slug === articleSlug);
    if (!article) return undefined;

    const articleLang = article.languages?.includes(language) ? language : 'en';
    const response = await fetch(
      `/articles/${articleLang}/${encodeURIComponent(articleSlug)}.md?t=${Date.now()}`
    );
    const text = await response.text();
    const { attributes } = matter(text);
    const attrs = attributes as Record<string, unknown>;

    return { ...article, ...attrs } as ArticleMetadata;
  } catch (error) {
    console.error(`Error loading metadata for ${articleSlug}:`, error);
    return undefined;
  }
}

export function resolveArticleLang(article: Article, currentLang: string): string {
  return article.languages?.includes(currentLang) ? currentLang : 'en';
}

export function useCurrentLang(): string {
  const { lang } = useParams<{ lang: string }>();
  const { i18n } = useTranslation();
  return lang || i18n.language.split('-')[0];
}
